import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import React, {useEffect} from "react";
import {getFormData} from "../../models/recurringExpenseModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {fetchRecurringExpenseById, updateRecurringExpense} from "../../store/recurring-expense-slice";
import {fetchNotApplicableList} from "../../store/list-slice";
import {recurringExpenseSchema} from "../../schema/recurringExpenseSchema";

const RecurringExpenseEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {pagination} = useSelector(state => state.recurringExpense);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.recurringExpense);
    const list = useSelector(state => state.list);

    useEffect(() => {
        dispatch(fetchRecurringExpenseById({...userRole, id: params.recurringExpenseId}));
    }, [dispatch, params.recurringExpenseId, userRole]);

    const recurring = items.find(item => item.id === params.recurringExpenseId);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch])

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        dispatch(updateRecurringExpense({
            ...userRole,
            id: params.recurringExpenseId,
            data: data
        }));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const schema = recurringExpenseSchema({list});
    const initialData = getFormData(recurring);
    return (
        <>
            <SubHeader title="Update Recurring Expense">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default RecurringExpenseEdit;